/* bangerfabrique theme behaviour
   - SCM music player (local audio file; Spotify embed is an optional later upgrade)
   - swatch / variant selection on the product page
   Kept dependency-free so it works the same in the Shopify theme and in preview.html. */
(function () {
  "use strict";

  /* ---------- SCM music player (playlist; shows current track name) ---------- */
  function initPlayer() {
    var root = document.querySelector("[data-bfq-player]");
    if (!root) return;
    var audio = root.querySelector("audio");
    var playBtn = root.querySelector("[data-bfq-play]");
    var nextBtn = root.querySelector("[data-bfq-next]");
    var fill = root.querySelector(".bfq-player__fill");
    var titleEl = root.querySelector("[data-bfq-track]");
    var dataEl = root.querySelector("[data-bfq-playlist]");
    var iconPlay = "M8 5v14l11-7z";
    var iconPause = "M6 5h4v14H6zM14 5h4v14h-4z";
    if (!audio) return;

    var playlist = [];
    try { playlist = JSON.parse(dataEl ? dataEl.textContent : "[]"); } catch (e) { playlist = []; }
    if (!playlist.length) return;

    var index = 0;

    function setIcon(path) {
      var p = playBtn && playBtn.querySelector("path");
      if (p) p.setAttribute("d", path);
    }
    function label(i) {
      if (titleEl) titleEl.textContent = (playlist[i] && playlist[i].name) || "track";
    }
    function load(i, autoplay) {
      index = (i + playlist.length) % playlist.length;
      var track = playlist[index];
      label(index);
      if (fill) fill.style.width = "0%";
      if (track && track.src) {
        audio.src = track.src;
        if (autoplay) {
          audio.play().then(function () { setIcon(iconPause); }).catch(function () {});
        }
      }
    }

    load(0, false); // show first track name up front, don't autoplay (browsers block it)

    if (playBtn) {
      playBtn.addEventListener("click", function () {
        if (!playlist[index] || !playlist[index].src) return;
        if (audio.paused) {
          audio.play().then(function () { setIcon(iconPause); }).catch(function () {});
        } else {
          audio.pause();
          setIcon(iconPlay);
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () { load(index + 1, true); });
    }
    audio.addEventListener("timeupdate", function () {
      if (fill && audio.duration) {
        fill.style.width = ((audio.currentTime / audio.duration) * 100).toFixed(1) + "%";
      }
    });
    audio.addEventListener("ended", function () {
      if (playlist.length > 1) { load(index + 1, true); } else { setIcon(iconPlay); }
    });
  }

  /* ---------- product page: variant / swatch selection ---------- */
  function initSwatches() {
    var groups = document.querySelectorAll("[data-bfq-swatches]");
    groups.forEach(function (group) {
      group.addEventListener("click", function (e) {
        var btn = e.target.closest(".bfq-swatch");
        if (!btn) return;
        group.querySelectorAll(".bfq-swatch").forEach(function (b) {
          b.classList.remove("bfq-swatch--active");
        });
        btn.classList.add("bfq-swatch--active");
        var hidden = group.parentElement.querySelector("input[type=hidden]");
        if (hidden && btn.dataset.value) hidden.value = btn.dataset.value;
      });
    });
  }

  /* ---------- background video: random clip from the list, hide fallback on play ---------- */
  function initBackground() {
    var video = document.querySelector(".bfq-bg__video");
    var fallback = document.querySelector(".bfq-bg__fallback");
    if (!video) return;
    if (fallback) video.addEventListener("canplay", function () { fallback.style.display = "none"; });
    var list = [];
    try { list = JSON.parse(video.getAttribute("data-bfq-videos") || "[]").filter(Boolean); } catch (e) { list = []; }
    if (list.length > 1) {
      var pick = list[Math.floor(Math.random() * list.length)];
      var current = video.currentSrc || "";
      if (pick && current.indexOf(pick) === -1) {
        video.src = pick;
        video.load();
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }
  }

  /* ---------- landing/password: reveal the password entry on demand ---------- */
  function initLandingToggle() {
    var toggle = document.querySelector("[data-bfq-pw-toggle]");
    var panel = document.querySelector("[data-bfq-pw]");
    if (!toggle || !panel) return;
    toggle.addEventListener("click", function () {
      var open = panel.hasAttribute("hidden");
      if (open) { panel.removeAttribute("hidden"); } else { panel.setAttribute("hidden", ""); }
      toggle.setAttribute("aria-expanded", String(open));
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () { initPlayer(); initSwatches(); initBackground(); initLandingToggle(); });
})();
